import React from 'react'
import { MANTHLY_DUE_ITEM_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyDueItemForm from './ManthlyDueItemForm'

export default function ManthlyDueItemUpdate({ onCancel, onSuccess, reportItem, finance, dueDate }) {
    console.log(reportItem.id)
    const url = MANTHLY_DUE_ITEM_DETAIL.replace('{id}', reportItem.id)
    const rotationItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await rotationItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={rotationItemUpdate.error} />
            <ManthlyDueItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                dueDate={dueDate}
                finance={finance}
                loading={rotationItemUpdate.loading} />
        </div>
    )
}
